import { render, staticRenderFns } from "./GeneralSpecialtyForm.vue?vue&type=template&id=365b1838&"
import script from "./GeneralSpecialtyForm.vue?vue&type=script&lang=js&"
export * from "./GeneralSpecialtyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports